import React, { useState } from "react";
import { toast } from "@jsq/ds/core";
import { DATA_VAULT_CONTEXT } from "../../../constants";
import { useSections } from "../../hooks/useSections";
import { CreateSectionInput, Tab } from "../../types";
import SectionModal from "../SectionModal";

interface Props {
  show: boolean;
  onHide: () => void;
  tabs?: Tab[];
}

export const initialValues: CreateSectionInput = {
  name: "",
  description: "",
  context: DATA_VAULT_CONTEXT,
  tabName: "",
};

const CreateSectionModal: React.FC<Props> = ({ show, onHide, tabs = [] }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { createSection } = useSections();

  const handleSubmit = async (values: Partial<CreateSectionInput>) => {
    try {
      setIsSubmitting(true);

      const sectionInput: CreateSectionInput = {
        name: (values.name || "").trim(),
        description: values.description?.trim(),
        context: initialValues.context,
        tabName: values.tabName?.trim(),
      };

      await createSection(sectionInput);
      toast.success("Section created successfully");
      onHide();
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : "Failed to create section";
      toast.error(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <SectionModal<CreateSectionInput>
      show={show}
      onHide={onHide}
      title="Create section"
      submitButtonText="Create"
      submitButtonTestId="create-section-submit"
      isSubmitting={isSubmitting}
      initialValues={initialValues}
      onSubmit={handleSubmit}
      isEditMode={false}
      tabs={tabs}
    />
  );
};

export default CreateSectionModal;
